import { jsx } from 'react/jsx-runtime';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store.js';

const StoreProvider = (props) => (jsx(Provider, { store: store, children: jsx(PersistGate, { loading: null, persistor: persistor, children: props.children }) }));

export { StoreProvider };
